var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkPlusOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "var(--color-primary)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 1.83346V.500122h-1.3333V1.83346h-1.3333v1.33333h1.3333v1.33333h1.3333V3.16679h1.3334V1.83346h-1.3334ZM6.66675 1.83366h2.66667v1.33333H6.66675c-.6395 0-1.05235.00072-1.36832.02228-.304.02074-.41978.05623-.47526.07922-.3267.13532-.58627.39489-.7216.72159-.02298.05549-.05847.17126-.07921.47526-.02156.31597-.02228.72882-.02228 1.36832l.00001 7.73084 4-2.6666 4.00001 2.6666V5.83346l1.3333.0002V15.167h-1.3333l-4.00001-2.6667-4 2.6667H2.66676l-.00001-9.33334c0-1.24251 0-1.86377.20299-2.35382.27065-.65341.78978-1.17254 1.44318-1.44319.49006-.20299 1.11132-.20299 2.35383-.20299Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .500122)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkPlusOutline);
export default __webpack_public_path__ + "static/media/bookmarkPlusOutline.32cc41b230e5f36ea1a9f940e9e7a9e9.svg";
export { ForwardRef as ReactComponent };